var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];
export default {
  plugins: [],
  prefixMap: {
    "appearance": wm,
    "textEmphasisPosition": w,
    "textEmphasis": w,
    "textEmphasisStyle": w,
    "textEmphasisColor": w,
    "boxDecorationBreak": w,
    "maskImage": w,
    "maskMode": w,
    "maskRepeat": w,
    "maskPosition": w,
    "maskClip": w,
    "maskOrigin": w,
    "maskSize": w,
    "maskComposite": w,
    "mask": w,
    "maskBorderSource": w,
    "maskBorderMode": w,
    "maskBorderSlice": w,
    "maskBorderWidth": w,
    "maskBorderOutset": w,
    "maskBorderRepeat": w,
    "maskBorder": w,
    "maskType": w,
    "textDecorationStyle": w,
    "textDecorationSkip": w,
    "textDecorationLine": w,
    "textDecorationColor": w,
    "userSelect": wmms,
    "backdropFilter": w,
    "fontKerning": w,
    "scrollSnapType": wms,
    "scrollSnapPointsX": wms,
    "scrollSnapPointsY": wms,
    "scrollSnapDestination": wms,
    "scrollSnapCoordinate": wms,
    "clipPath": w,
    "shapeImageThreshold": w,
    "shapeImageMargin": w,
    "shapeImageOutside": w,
    "filter": w,
    "hyphens": wms,
    "flowInto": wms,
    "flowFrom": wms,
    "breakBefore": wms,
    "breakAfter": wms,
    "breakInside": wms,
    "regionFragment": wms,
    "writingMode": wms,
    "textOrientation": w,
    "tabSize": m,
    "fontFeatureSettings": w,
    "columnCount": w,
    "columnFill": w,
    "columnGap": w,
    "columnRule": w,
    "columnRuleColor": w,
    "columnRuleStyle": w,
    "columnRuleWidth": w,
    "columns": w,
    "columnSpan": w,
    "columnWidth": w,
    "wrapFlow": ms,
    "wrapThrough": ms,
    "wrapMargin": ms,
    "textSizeAdjust": wms
  }
};